import { Brand } from "../brand";

export function NavBar() {
  return (
    <nav
      className="navbar navbar-dark sticky-top"
      style={{
        backgroundColor: "#0087CD",
      }}
    >
      <div className="container justify-content-center">
        <Brand />

        {/* <div className="navbar-brand">Formulario de pre-registro en línea</div> */}
      </div>
    </nav>
  );
}
